import { PatternsDarkTheme } from "../.internal/themes/PatternsDarkTheme";
export default PatternsDarkTheme;
